import { useTranslation } from 'react-i18next';
import { useGetInvestingStatus } from '@/query/queries/investing/useGetInvestingStatus';
import { useGetBalance } from '@/query/queries/cash/useGetBalance';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import r from '@/kit/RoundButton/button.module.scss';

export const Button = () => {
  const { t } = useTranslation('calculator');
  const { data: status } = useGetInvestingStatus();
  const { data: balance } = useGetBalance();

  if (!status || !balance) return null

  const totalBalance = balance.available + balance.available_bonus_amount;
  const hasMoney = Math.floor(totalBalance * 100) / 100 > 0;
  const isInvested = status.is_participating;
  const roundActive = status.is_active;

  if (!roundActive && hasMoney) return null;

  if (!hasMoney) return (
    <MyLink href={APP_LINKS.addFunds} className={r.yellow_base}>
      {t('growth.add_cash')}
    </MyLink>
  );

  if (isInvested && roundActive && balance.available) return (
    <MyLink href={APP_LINKS.investing} className={r.yellow_base}>
      {t('growth.invest_more')}
    </MyLink>
  );

  if (roundActive && hasMoney) return (
    <MyLink href={APP_LINKS.investing} className={r.yellow_base}>
      {t('growth.join_round')}
    </MyLink>
  );

  return null;
};